import React from "react";
import { Link } from "react-router-dom";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import MailIcon from '@mui/icons-material/Mail';

import "./Footer.css";

import logo from "../../assets/logo2r.png";

const Footer = () => {
  return (
    <div
      className="container-fluid text-light footer pt-5 mt-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div>
        <footer className="footerBackground">
          {/* <div className="footerBackground1"></div> */}
          <div className="container container1 py-5">
            <div className="row g-5">
              <div className="col-lg-3 col-md-6">
                <h4 className="text-white mb-3">Quick Link</h4>
                <Link className="btn btn-link" to="http://result:8080/" target="_blank">
                  Result:8080
                </Link>
                <Link className="btn btn-link" to="#">
                  How to Reach
                </Link>
                <Link className="btn btn-link" to="#">
                  Alumini
                </Link>
                <Link className="btn btn-link" to="#">
                  SSIT News Letters
                </Link>
                <Link className="btn btn-link" to="#">
                  Downloads
                </Link>
                <Link
                  className="btn btn-link"
                  to="https://mail.google.com/"
                  target="_blank"
                >
                  Webmail
                </Link>
                <Link className="btn btn-link" to="/gallery/login">
                  Login
                </Link>
                {/* <Link className="btn btn-link" to="/gallery/register">
              Register
            </Link> */}
              </div>
              <div className="col-lg-3 col-md-6">
                <h4 className="text-white mb-3">Contact</h4>
                <p className="mb-2">
                 Sai Spurthi
                  Institute Of Technology B.Gangaram (V), Sathupalli (Mandal),
                  Khammam District,Telangana-507303,
                  <br />
                  08761-288544,
                </p>
                <p className="mb-2">
                  <PhoneMissedIcon/>&ensp;Principal - +91
                  9963084558,
                  {/* <br /> Director - +91 9491109564, */}
                </p>
                <p className="mb-2">
                  <MailIcon/>&ensp;
                  sssit.principal@gmail.com
                </p>

                <p className="mb-2">
                  <MailIcon/>&ensp;For Microsoft Support :
                  &ensp;&ensp;principal_c5@saispurthi.ac.in
                </p>

                <p className="mb-2">
                <PhoneMissedIcon/>&ensp;Microsoft Support :
                  +918247251227
                </p>
                <div className="d-flex pt-2">
                  <a
                    className="btn btn-outline-dark btn-social custom-twitter-button rounded-circle p-1 "
                    href="https://twitter.com/i/flow/login?redirect_after_login=%2FSaiSpurthiMedia"
                    target="_blank"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      padding: "0",
                     
                    }}
                  >
                    <TwitterIcon style={{ color: "white", fontSize: "30px" }} />
                  </a>
                  <Link
                    className="btn btn-outline-dark btn-social rounded-circle p-1"
                    to="https://www.facebook.com/people/Sai-Spurthi-Media/61550019525949/"
                    target="_blank"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      padding: "0",
                    }}
                  >
                    <FacebookIcon
                      style={{ color: "white", fontSize: "30px" }}
                    />
                  </Link>
                  <Link
                    className="btn btn-outline-dark btn-social rounded-circle p-1"
                    to="https://www.youtube.com/@saispurthimedia"
                    target="_blank"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      padding: "0",
                    }}
                  >
                    <YouTubeIcon style={{ color: "white", fontSize: "30px" }} />
                  </Link>
                  <Link
                    className="btn btn-outline-dark btn-social rounded-circle p-1"
                    to="https://www.linkedin.com/in/sai-spurthi-b4107835b/"
                    target="_blank"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      padding: "0",
                    }}
                  >
                    <LinkedInIcon
                      style={{ color: "white", fontSize: "30px" }}
                    />
                  </Link>
                  <Link
                    className="btn btn-outline-dark btn-social rounded-circle p-1"
                    to="https://www.instagram.com/saispurthimedia/"
                    target="_blank"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      padding: "0",
                    }}
                  >
                    <InstagramIcon
                      style={{ color: "white", fontSize: "30px" }}
                    />
                  </Link>
                  <Link
                    className="btn btn-outline-dark btn-social rounded-circle p-1"
                    to="https://in.pinterest.com/saispurthimedia/"
                    target="_blank"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      padding: "0",
                    }}
                  >
                    <PinterestIcon
                      style={{ color: "white", fontSize: "30px" }}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <h4 className="text-white mb-3"></h4>
                {/* <img className="img-fluid p-1" src={logo} alt="logo-img" /> */}
                {/* <div className="row g-2 pt-2">
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src={course1}
                  alt="course1-img"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src={course2}
                  alt="course2-img"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src={course3}
                  alt="course3-img"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src={course2}
                  alt="course2-img"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src={course3}
                  alt="course3-img"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src={about}
                  alt="about-img"
                />
              </div>
            </div> */}
              </div>
              <div className="col-lg-3 col-md-6">
                <h4 className="text-white mb-3">Newsletter</h4>
                {/* <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p> */}
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3811.4475007145784!2d80.89722767491565!3d17.19706700826053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a36840a244401e1%3A0x894ee441b464d070!2sSai%20Spurthi%20Institute%20Of%20Technology!5e0!3m2!1sen!2sin!4v1744119066511!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style={{borderRadius:"10px"}}></iframe>
                <div
                  className="position-relative mx-auto"
                  style={{ maxWidth: "400px" }}
                >
                  <input
                    className="form-control border-0 w-100 py-3 ps-4 pe-5"
                    type="text"
                    placeholder="Your email"
                  />
                  <button
                    type="button"
                    className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                  >
                    SignUp
                  </button>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div
        className="container mw-100"
        style={{ background: "rgb(44,38,138)" }}
      >
        <div className="copyright">
          <div className="row">
            <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
              
              {/* <Link className="border-bottom" to="#"> */}
               <b> © Copy Rights 2025</b>
              {/* </Link> */}
             <b>  , All Right Reserved Sai Spurthi Institute of Technology  ||  </b>
              {/* This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. */}
              <b>Designed By{" "}</b>
              <Link className="border-bottom" target="_blank" to="https://adiversetech.com/">
               <b> Adiverse Technologies</b>
              </Link>
            </div>
            <div className="col-md-4 text-center text-md-end">
              <div className="footer-menu">
                <Link to="#">Home</Link>
                <Link to="#">Cookies</Link>
                <Link to="#">Help</Link>
                <Link to="#">FQAs</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
